import { MiningPatternDocument } from '../MiningPattern/queryBuilder';
import { PanelDocument } from '../Panels/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { RoomDocument, roomsPullQueryBuilder } from './queryBuilder';

export function roomsFamilyMember(
  configBuilder: ConfigBuilder,
  miningPatterns: FamilyMember<MiningPatternDocument>,
  panels: FamilyMember<PanelDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<RoomDocument> {
  const syncConfig = configBuilder<RoomDocument>(RxdbCollectionNameV2.ROOMS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, roomsPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy sets the syncInterval to LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.ROOMS, replicationState, [miningPatterns, panels, sites]);
}
